import { useSelector } from 'react-redux';

import HoldCancelClubMembership from 'profile/clubMembership/holdCancel/HoldCancelClubMembership';
import UpcomingCancelMessage from 'profile/clubMembership/holdCancel/UpcomingCancelMessage';
import UpcomingHoldMessage from 'profile/clubMembership/holdCancel/UpcomingHoldMessage';

import PaymentDetails from '../../components/PaymentDetails';
import ShipTo from '../../components/ShipTo';
import { isUpcomingHold, isUpcomingCancel } from '../../helpers';
import ClubShipDate from '../../shipment/components/traditional/ClubShipDate';

import ManualItems from './traditional/ManualItems';
import ShipItNow from './traditional/ShipItNow';
import ShipmentItemsPricingFromProducts from './traditional/ShipmentItemsPricingFromProducts';

const ActiveControlledSubscriptionWithShipment = (props) => {
  const { clubMembership, router = 'router' } = props;
  const clubPackage = useSelector(
    (state) => state.clubPackage.data[clubMembership.activeClubPackageId]
  );
  const clubMemberShipment = useSelector(
    (state) =>
      state.clubMemberShipment.data[clubMembership.activeClubMemberShipmentId]
  );

  return (
    <div className="c7-account__club-status">
      <div>
        <h3>
          {clubMembership.club.title} {renderUpcomingHold(clubMembership)}
        </h3>
        <ClubShipDate
          clubMemberShipment={clubMemberShipment}
          clubPackage={clubPackage}
          router={router}
        />
        <br />
        <UpcomingCancelMessage clubMembership={clubMembership} />
        <UpcomingHoldMessage clubMembership={clubMembership} />

        {router === 'router' && (
          <ShipItNow
            clubMembership={clubMembership}
            clubPackage={clubPackage}
            clubMemberShipment={clubMemberShipment}
          />
        )}
        <br />
        <br />
      </div>

      <div className="c7-account-row">
        <div>
          <div className="c7-account-tile__section">
            <ShipTo clubMembership={clubMembership} />
          </div>
          <br />
          <div className="c7-account-tile__section">
            <PaymentDetails clubMembership={clubMembership} />
          </div>
          <br />
          {router === 'router' && (
            <HoldCancelClubMembership
              clubMembership={clubMembership}
              clubMemberShipment={clubMemberShipment}
            />
          )}
          {router === 'noRouter' && (
            <div className="c7-club-actions c7-club-actions--hold-cancel">
              <a href={`/profile/club-membership/${clubMembership.id}`}>
                Edit club membership
              </a>
            </div>
          )}
        </div>
        <ShipmentItemsPricingFromProducts
          clubMembership={clubMembership}
          clubPackage={clubPackage}
          clubMemberShipment={clubMemberShipment}
          isPersonalizationBlock={router === 'noRouter' || false}
        />
      </div>
      <ManualItems clubMembership={clubMembership} />
    </div>
  );
};

const renderUpcomingHold = (clubMembership) => {
  if (isUpcomingCancel(clubMembership)) {
    return (
      <>
        <em>(Upcoming Cancellation)</em>
      </>
    );
  }
  if (isUpcomingHold(clubMembership)) {
    return (
      <>
        <em>(Upcoming Hold)</em>
      </>
    );
  }
  return null;
};

export default ActiveControlledSubscriptionWithShipment;
